import IAdvertBanner from '../../models/advert-banner/IAdvertBanner';
import IAdvertBannerGql from '../../models/advert-banner/IAdvertBannerGql';
import { BackgroundImage, CallToAction } from '../../models/course/ICourseContent';

export function getAdvertBannerContent(advertBannerContent: IAdvertBannerGql) {
  const advertBannerCTA: CallToAction = {
    fields: {
      text: advertBannerContent.callToAction.text ?? null,
      url: advertBannerContent.callToAction.url ?? null,
      buttonName: advertBannerContent.callToAction.buttonName ?? null,
      buttonStyle: advertBannerContent.callToAction.buttonStyle ?? null,
      buttonSize: advertBannerContent.callToAction.buttonSize ?? null,
      target: advertBannerContent.callToAction.target ?? null,
    },
  };

  const advertBannerBackgroundImage: BackgroundImage = {
    fields: {
      image: [
        {
          secure_url: advertBannerContent.backgroundImage.secureUrl ?? null,
        },
      ],
    },
  };

  const advertContent: IAdvertBanner = {
    application: advertBannerContent.application ?? null,
    headline: advertBannerContent.headline ?? null,
    headlineTextColor: advertBannerContent.headlineTextColor ?? null,
    paragraph: advertBannerContent.paragraph ?? null,
    paragraphTextColor: advertBannerContent.paragraphTextColor ?? null,
    paragraphContainerColor: advertBannerContent.paragraphContainerColor ?? null,
    paragraphContainerColorOpacity: advertBannerContent.paragraphContainerColorOpacity ?? null,
    callToAction: advertBannerCTA,
    backgroundImage: advertBannerBackgroundImage,
    backgroundImageColor: advertBannerContent.backgroundImageColor ?? null,
  };

  return advertContent;
}

export function checkAdvertBannerContentExists(advertBannerContent: any) {
  if (
    advertBannerContent?.headline &&
    advertBannerContent?.paragraph &&
    advertBannerContent?.backgroundImage &&
    (advertBannerContent?.backgroundImage?.secureUrl ??
      advertBannerContent?.backgroundImage?.fields?.image) &&
    advertBannerContent?.callToAction &&
    (advertBannerContent?.callToAction?.text ?? advertBannerContent?.callToAction.fields?.text) &&
    (advertBannerContent?.callToAction?.buttonName ??
      advertBannerContent?.callToAction.fields?.buttonName) &&
    (advertBannerContent?.callToAction?.url ?? advertBannerContent?.callToAction.fields?.url)
  ) {
    return true;
  }

  return false;
}
